module.exports = __webpack_public_path__ + "us.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/us.svg
// module id = 1123
// module chunks = 0